import { render, staticRenderFns } from "./page-btn.vue?vue&type=template&id=ed558488&scoped=true&"
import script from "./page-btn.vue?vue&type=script&lang=js&"
export * from "./page-btn.vue?vue&type=script&lang=js&"
import style0 from "./page-btn.vue?vue&type=style&index=0&id=ed558488&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed558488",
  null
  
)

export default component.exports